import actionTypes from '../actionTypes';

const initialState = {
  teamList: [],
  team: {}
};

export default (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.PROFILE_TEAM_LIST: {
      let teamList = action.payload.teamList || [];
      newState.teamList = teamList;
      // set first team as default Team
      if (teamList && teamList[0] && teamList[0]._id) {
        newState.team = { _id: teamList[0]._id };
      }
      return newState;
    }
    case actionTypes.PROFILE_TEAM:
      newState.team = action.payload.team;
      return newState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/store/reducers/profile.reducer.js